var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.72,
    fill: "#00D998"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20186_136123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 24.334H16.8333C20.9755 24.334 24.3333 20.9762 24.3333 16.834C24.3333 12.6919 20.9755 9.33398 16.8333 9.33398C12.9728 9.33398 9.74783 12.2507 9.33329 16.0007",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4166 10.5833L22.25 9.75M10.5833 9.75L11.4166 10.5833",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 13.5L17.3007 15.9495M17.3007 15.9495C17.0744 15.7232 16.7619 15.5833 16.4167 15.5833C15.7264 15.5833 15.1667 16.143 15.1667 16.8333C15.1667 17.5237 15.7264 18.0833 16.4167 18.0833C17.1071 18.0833 17.6667 17.5237 17.6667 16.8333C17.6667 16.4881 17.5268 16.1756 17.3007 15.9495Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4166 8.91797V7.66797",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.66797H18.0833",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 18.5H10.1666",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 21.834H11.8333",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20186_136123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstReply);
export default __webpack_public_path__ + "static/media/firstReply.6efd86ead134c3d1a5e9c4339f95aac0.svg";
export { ForwardRef as ReactComponent };